const scrollToContact = () => {
  const el = document.getElementById('contact');
  if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - 80, behavior: 'smooth' });
};

const coatingTypes = [
  {
    id: 'ceramic',
    icon: 'ri-shield-flash-fill',
    type: 'Ceramic Coatings',
    subtitle: 'Ceramic Plus 10H Radical™ · Borophene 3.0 & 4.0 · BOROGRAPH 3.0 "Stealth"',
    description: 'Permanent surface bond in a single layer. Maximum gloss, hydrophobic repellency, and UV protection. Best for professional detailers, automotive fleets, and high-end vehicles. Includes the full Borophene and Borograph lineup.',
    bestFor: 'Automotive · Marine · Aviation · Residential',
    strength: 'Permanent protection, high gloss, maximum hardness',
    tag: 'MOST POPULAR',
  },
  {
    id: 'specialty',
    icon: 'ri-magic-fill',
    type: 'Specialty Coatings',
    subtitle: 'Black Pearl · Matte Plus · EZ Glass™ · Wheel & Caliper™ · Leather · Fabric',
    description: 'Purpose-built formulations for specific surface types or finish requirements. Covers wheels, glass, leather, fabric, carpet, rubber, vinyl convertible tops, and more — each engineered for its exact surface.',
    bestFor: 'Matte finishes · Dark paint · Wheels · Interior surfaces · Glass',
    strength: 'Targeted protection for unique surfaces',
  },
  {
    id: 'lpf',
    icon: 'ri-stack-fill',
    type: 'Liquid PPF',
    subtitle: 'NANOPRO LIQUID PAINT PROTECTION FILM KIT (LPF ACCELERATE™)',
    description: 'PPF-level paint protection without the traditional installation process. One 120mL bottle covers a full vehicle. Ideal when you need paint protection beyond ceramic\'s scratch resistance — no film, no removal.',
    bestFor: 'High-use vehicles · Front-end protection · PPF alternative',
    strength: 'Physical paint protection, scratch resistance',
    tag: 'NEW 2025/26',
  },
  {
    id: 'color-ppf',
    icon: 'ri-palette-fill',
    type: 'Color Change PPF',
    subtitle: 'LPF Color Change Kit · NANOPRO® MATTE LPF',
    description: 'Liquid PPF with color change or matte finish capability. Apply paint protection and transform your vehicle\'s color or preserve its matte/satin finish simultaneously — PPF-level protection without traditional film.',
    bestFor: 'Color change vehicles · Matte & satin paint jobs',
    strength: 'Color transformation + PPF-level protection',
    tag: 'NEW 2025/26',
  },
  {
    id: 'tint',
    icon: 'ri-eye-2-fill',
    type: 'Window Tint',
    subtitle: 'MEDIUM - W.O.W. (WIPE ON WINDOW TINT) BY NANOPRO®',
    description: 'The industry\'s only hand-applied wipe-on window tint. No traditional film installation. Applied like a coating — medium shade available exclusively to Certified NanoPro® Installers for automotive and residential windows.',
    bestFor: 'Automotive · Residential windows',
    strength: 'No installation process, easy wipe-on application',
    tag: 'NEW 2025/26',
  },
  {
    id: 'marine',
    icon: 'ri-ship-fill',
    type: 'Marine Coatings',
    subtitle: 'Nautilus 250mL Marine Sio3™ · Wood Plus™ Ceramic Coating',
    description: 'Engineered specifically for constant saltwater and UV exposure. Marine-grade adhesion, anti-fouling resistance, and permanent hull gloss for boats and watercraft. Wood Plus™ covers marine woodwork and decks.',
    bestFor: 'Boats · Yachts · Marine vessels · Wood decks',
    strength: 'Saltwater resistance, permanent hull & wood protection',
  },
];

const HowToChooseSection = () => (
  <section id="how-to-choose" className="bg-[#060606] py-24 lg:py-32 border-t border-white/5">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-14">

      {/* ── Header ── */}
      <div className="grid lg:grid-cols-2 gap-12 items-end mb-16">
        <div>
          <div className="flex items-center gap-4 mb-5">
            <div className="h-px w-10 bg-[#c9a84c]" />
            <p className="text-[#c9a84c] text-[10px] tracking-[0.32em] font-black">COATING SELECTION GUIDE</p>
          </div>
          <h2
            className="text-white font-black leading-[0.95]"
            style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 'clamp(32px, 4.6vw, 58px)', letterSpacing: '-0.03em' }}
          >
            Which System<br />
            <span className="text-gold-gradient">Is Right for You?</span>
          </h2>
        </div>
        <div>
          <p className="text-white/38 text-[15px] leading-[1.9] mb-5">
            NanoPro® offers multiple coating systems — each engineered for a specific surface type, 
            application environment, or performance requirement. Understanding the difference helps 
            you choose the right protection.
          </p>
          <p className="text-white/22 text-[12px] leading-[1.75] border-l-2 border-[#c9a84c]/30 pl-4">
            Not sure which system fits your application? Contact Surface Solutions of CT — we guide you to the right formulation before you purchase.
          </p>
        </div>
      </div>

      {/* ── Coating type cards ── */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5">
        {coatingTypes.map((type) => (
          <div
            key={type.id}
            className="bg-[#060606] p-8 group hover:bg-[#0d0d0d] transition-colors duration-300 relative overflow-hidden flex flex-col"
          >
            {/* Top row */}
            <div className="flex items-start justify-between gap-4 mb-6">
              <div className="w-10 h-10 flex items-center justify-center border border-[#c9a84c]/20 flex-shrink-0 group-hover:border-[#c9a84c]/50 transition-all duration-300">
                <i className={`${type.icon} text-[#c9a84c] text-[18px]`} />
              </div>
              {type.tag && (
                <span className="px-2.5 py-1 bg-[#c9a84c]/10 border border-[#c9a84c]/22 text-[#c9a84c] text-[8px] font-black tracking-[0.18em] flex-shrink-0 whitespace-nowrap">
                  {type.tag}
                </span>
              )}
            </div>

            {/* Type name */}
            <h3
              className="text-white font-bold leading-snug mb-1"
              style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 'clamp(15px, 1.3vw, 17px)' }}
            >
              {type.type}
            </h3>
            <p className="text-[#c9a84c] text-[10px] tracking-[0.16em] font-black mb-5">{type.subtitle}</p>

            {/* Description */}
            <p className="text-white/38 text-[12px] leading-[1.85] flex-1 mb-6">{type.description}</p>

            {/* Specs */}
            <div className="flex flex-col gap-2 mb-7 pt-5 border-t border-white/6">
              <div className="flex items-start gap-2.5">
                <span className="text-white/28 text-[10px] tracking-[0.12em] font-bold flex-shrink-0 mt-0.5">BEST FOR</span>
                <span className="text-white/52 text-[11px] leading-[1.65]">{type.bestFor}</span>
              </div>
              <div className="flex items-start gap-2.5">
                <span className="text-white/28 text-[10px] tracking-[0.12em] font-bold flex-shrink-0 mt-0.5">STRENGTH</span>
                <span className="text-white/52 text-[11px] leading-[1.65]">{type.strength}</span>
              </div>
            </div>

            {/* CTA */}
            <button
              onClick={scrollToContact}
              className="inline-flex items-center gap-2 text-[#c9a84c] text-[10px] font-black tracking-[0.14em] hover:gap-4 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              ASK ABOUT THIS SYSTEM <i className="ri-arrow-right-line text-[11px]" />
            </button>

            <div className="mt-5 h-px w-5 bg-[#c9a84c]/25 group-hover:w-12 transition-all duration-400" />
          </div>
        ))}
      </div>

      {/* ── Bottom advisory bar ── */}
      <div className="mt-0 border border-t-0 border-white/5 bg-[#0a0a0a] px-8 lg:px-12 py-8 flex flex-col lg:flex-row items-center justify-between gap-6">
        <div className="flex items-start gap-5 max-w-[640px]">
          <div className="w-10 h-10 flex items-center justify-center border border-[#c9a84c]/25 flex-shrink-0 mt-0.5">
            <i className="ri-customer-service-2-fill text-[#c9a84c] text-[18px]" />
          </div>
          <div>
            <h4 className="text-white font-bold text-[15px] mb-1" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
              Still Not Sure? We Guide You.
            </h4>
            <p className="text-white/38 text-[13px] leading-[1.75]">
              Surface Solutions of CT's role isn't just reselling — it's matching the right NanoPro® system to your exact surface and application requirements. Reach out with your use case.
            </p>
          </div>
        </div>
        <button
          onClick={scrollToContact}
          className="flex-shrink-0 px-9 py-4 bg-[#c9a84c] text-[#030303] text-[11px] font-black tracking-[0.18em] hover:bg-[#e0bf6a] transition-colors cursor-pointer whitespace-nowrap"
        >
          GET COATING GUIDANCE
        </button>
      </div>
    </div>
  </section>
);

export default HowToChooseSection;
